/**
 * LEADER serializer. The leader's path (tip → landing) exports as a native
 * LEADER (AcDbLeader); the note text rides along as a companion MTEXT at
 * the landing point, the classic QLEADER layout (annotation is a separate
 * text object referenced by the leader in full AutoCAD databases).
 */

import type { Entity } from '../../../../state/store';
import type { DxfWriteContext } from '../types';
import type { DxfStreamWriter } from '../DxfStreamWriter';
import { entityPrologue } from './common';
import { writeMText } from './textMtext';

export function writeLeader(w: DxfStreamWriter, ctx: DxfWriteContext, e: Entity, owner: string): void {
    const d = e.data as Record<string, any>;
    const tip = d.tip as number[], land = d.landing as number[];
    if (!Array.isArray(tip) || !Array.isArray(land)) return;

    entityPrologue(w, ctx, e, 'LEADER', owner);
    w.pair(100, 'AcDbLeader');
    w.pair(3, 'Standard');
    w.pair(71, 1); // arrowhead on
    w.pair(72, 0); // path type: straight
    w.pair(73, 3); // creation: text + leader + landing
    w.pair(74, 1); // hookline on
    w.pair(75, 0); // hook direction
    w.pair(40, 0.25); // text height (annotation rides separately)
    w.pair(41, 0); // text width (auto)
    w.pair(10, tip[0] ?? 0).pair(20, tip[1] ?? 0).pair(30, tip[2] ?? 0);
    w.pair(10, land[0] ?? 0).pair(20, land[1] ?? 0).pair(30, land[2] ?? 0);

    const text = String(d.text ?? '');
    if (!text) return;
    const mtext: Entity = {
        ...e,
        id: `dxf:${e.id}#note`,
        type: 'mtext',
        data: {
            content: text,
            position: [land[0] + 0.15, land[1], land[2] ?? 0],
            height: typeof d.textScale === 'number' && d.textScale > 0 ? 0.25 * d.textScale : 0.25,
            width: 0,
        },
    };
    writeMText(w, ctx, mtext, owner);
}
